import React from 'react';

import * as S from './styles';

const Slide6: React.FC = () => {
  return (
    <S.Container>
      <S.Image />
      <S.Content>
        <S.SubtitleMobile>
          Top, Moun, R$ 439. Calça, Louis Vuitton, R$ 8.000. Corset, collab
          Felipe Fanaia com UMS-480, R$ 590.
        </S.SubtitleMobile>
      </S.Content>
    </S.Container>
  );
};

export { Slide6 };
